import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectUser(data) {
  return request({
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // },
    url: `/admin/mini/user/select`,
    method: "POST",
    data,
  });
}

/**
 * 禁用
 * @param {*} data
 * @returns
 */
export function disableUser(data) {
  return request({
    url: `/admin/mini/user/disable`,
    method: "POST",
    data,
  });
}

/**
 * 编辑
 * @param {*} data
 * @returns
 */
export function updateUser(data) {
  return request({
    url: `/admin/mini/user/update`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteUser(data) {
  return request({
    url: `/admin/mini/user/delete`,
    method: "POST",
    data,
  });
}
